import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { SubstanceDrugsSupplementalPublicSafetyModel } from './types';
import substanceDrugsSupplementalPublicSafetyItemValidator from './validators/item';

const substanceDrugsSupplementalPublicSafetyValidator: ValidateJSModel<SubstanceDrugsSupplementalPublicSafetyModel> = {
  EmployedIllegalControlledSubstanceUseAnswer: { presence: true, hasValue: { validator: hasYesOrNo } },
  EmployedIllegalControlledSubstanceUseComment: {},
  EmployedIllegalControlledSubstanceUseSummaryComment: {},
  List: (value, attributes) => {
    if (attributes?.EmployedIllegalControlledSubstanceUseAnswer && attributes?.EmployedIllegalControlledSubstanceUseAnswer.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: substanceDrugsSupplementalPublicSafetyItemValidator },
      };
    }
    return {};
  },
};

export default substanceDrugsSupplementalPublicSafetyValidator;
